import _ from 'lodash';
import InlineEditors from '../../controllers/inlineEditors';
import keyboardNavigation from '../../grid/keyboardNavigation';
import Filter from '../../controllers/filter';

export default instance => {
  instance.attachEvent('onTaskIdChange', (id, newId) => {
    instance.showTask(newId);// for horizontal scrolling
    _.delay(() => {
      instance.getTask(newId)?.openEditAfterCreate && InlineEditors.startEdit(newId, 'text');
    });
  });

  instance.attachEvent('onTaskIdChange', (id, newId) => {
    instance.customTimelineTaskIdChange(id, newId);
  });

  instance.attachEvent('onTaskIdChange', (id, newId) => {
    keyboardNavigation.onTaskIdChange(id, newId);
    Filter.onTaskIdChange(id, newId);
  });
};
